import UsersListPage from "./users-list-page.jsx";

export default UsersListPage;
